import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    margin: 0,
    fontSize: 16,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  text: {
    display: 'block',
    fontSize: 14,
    color: theme.custom.darkBlue,
  },
  bold: {
    fontWeight: 600,
  },
  greyish: {
    marginTop: 10,
    color: 'rgba(48, 52, 75, .7)',
  },
  overflowX: {
    overflowX: 'hidden',
  },
  caseItem: {
    width: '100%',
    marginLeft: 5,
    marginRight: 5,
    padding: 15,
    borderRadius: 2,
    boxShadow: '0px 5px 16px rgba(112, 136, 210, 0.2)',
    cursor: 'pointer',
    [theme.breakpoints.down(400)]: {
      padding: '10px 0',
    },
  },
  caseItemTitle: {
    display: 'block',
    marginBottom: 10,
    fontSize: 15,
    fontWeight: 600,
    color: theme.custom.darkBlue,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 5,
    },
  },
  caseItemDate: {
    display: 'block',
    marginBottom: 20,
    fontSize: 12,
    fontWeight: 600,
    color: theme.custom.darkBlue,
    textTransform: 'uppercase',
    [theme.breakpoints.down('xs')]: {
      marginLeft: 5,
    },
  },
  arrowIcon: {
    fontSize: '1.3rem',
    color: theme.custom.darkBlue,
  },
  iconBtn: {
    '&.Mui-disabled': {
      opacity: '.3',
    },
  },
  weekDay: {
    fontSize: 11,
    letterSpacing: 2,
  },
  btn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 'auto',
    padding: '3px 20px',
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    fontWeight: 600,
    background: 'transparent',
    border: `2px solid ${theme.custom.lightBlue}`,
    borderRadius: 29,
    color: theme.custom.lightBlue,
  },
  modal: {
    padding: 15,
  },
  confirmationBtn: {
    fontSize: 13,
  },
  rejectBtn: {
    [theme.breakpoints.down('xs')]: {
      margin: 0,
      marginBottom: 15,
    },
  },
  confirmationBorder: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
}));
